import {NgModule} from '@angular/core';
// import { CommonModule } from '@angular/common';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatMenuModule} from '@angular/material/menu';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from '@angular/material/table';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSortModule} from '@angular/material/sort';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {MatTabsModule} from '@angular/material/tabs';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatCardModule} from '@angular/material/card';
import {MatExpansionModule} from '@angular/material/expansion';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatRippleModule, MatNativeDateModule, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {FileUploadModule} from 'ng2-file-upload';
import {CommonModule} from "@angular/common"; // Import the FileUploadModule

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        // BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        FileUploadModule
    ],
    exports: [
        MatToolbarModule,
        MatCardModule,
        MatButtonModule,
        MatFormFieldModule,
        MatMenuModule,
        MatPaginatorModule,
        MatRippleModule, MatGridListModule,
        MatDatepickerModule,
        MatDialogModule,
        MatInputModule,
        MatTableModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        MatSidenavModule,
        MatListModule,
        MatTabsModule, MatRadioModule, MatExpansionModule, MatSelectModule,
        FormsModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatNativeDateModule,
        MatSortModule,
        MatTooltipModule
    ],
    providers: [{provide: MAT_DATE_LOCALE, useValue: 'en-GB'}]
})
export class MaterialDesignModule {
}
